import React from "react";

const StatsSection = () => {
  const stats = [
    {
      value: "50k+",
      unit: "Metric Tons",
      label: "Annual Volume",
    },
    {
      value: "15+",
      unit: "Specialized Producers",
      label: "Mfg. Partners",
    },
    {
      value: "25+",
      unit: "Global Markets",
      label: "Export Reach",
    },
  ];

  return (
    <section className="flex justify-center w-full py-10 md:py-20 px-4 ">
      <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-10 w-full max-w-[1400px] justify-center items-center lg:items-stretch">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center gap-4 
                       w-full max-w-[400px] lg:flex-1
                       bg-white border border-[#343163] 
                       rounded-[40px] md:rounded-[60px] lg:rounded-[80px] 2xl:rounded-[120px] 
                       p-6 md:p-12 lg:p-10 xl:p-16
                       transition-all hover:shadow-xl hover:-translate-y-2 duration-300"
          >
            {/* Top Section: Number and Unit */}
            <div className="flex flex-col items-center text-center">
              <span className="text-[48px] md:text-[64px] lg:text-[80px] xl:text-[90px] font-bold leading-none text-[#343163]">
                {stat.value}
              </span>
              <span className="text-[16px] md:text-[18px] lg:text-[20px] font-medium text-[#1b0e02] opacity-70 mt-2">
                {stat.unit}
              </span>
            </div>

            {/* Divider Line (Optional for better UI) */}
            <div className="w-12 h-1 bg-[#343163] opacity-20 rounded-full"></div>

            {/* Bottom Section: Label */}
            <div className="text-[18px] md:text-[22px] lg:text-[28px] font-bold leading-tight text-center text-[#1b0e02]">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
